import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getPlants } from '../actions/plants';

import { Plant } from './index'

type PropsTag = {
  plant?: any;
  id?: number;
  isForm?: boolean;
  setCurrentTagId?: any;
  isSelected?: any;
  onClick?: (event: any) => void;
};

const Tag: React.FC<PropsTag> = ({ isSelected, isForm = false, plant, onClick }) => {

  const dispatch = useDispatch();
  const plants = useSelector((state: any) => state.plants)

  useEffect(() => {
    dispatch(getPlants())
  }, [dispatch])
  
  return (
    <>
      <section className=" _flex _flex-col _mx-sm ">
          <h1 className="_my-sm"> Liste des plantes </h1>
          <div className="_flex _flex-wrap margin-footer">
              {plants.map((plant, i) => {
                  return <Plant key={plant._id} plant={plant} />
              })}
          </div>
      </section>
    </>
  );
};

export default Tag;
